<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
    <div>
        <Breadcrumbs main="Work Management" title="Cancellation Requests" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-10 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchCancelledJobs()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1 float-end" placeholder="Search" v-model="keyword" @keyup="fetchCancelledJobs()"/>
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
                                            <th>Sl.No</th>
											<th>Work ID</th>
                                            <th>Customer</th>
											<th>Location</th>
											<th>Product & Work Type</th>
											<th>Requested Technician</th>
											<th>Reason</th>
											<th>Status</th>
											<th>Options</th>
                                        </tr>
									</thead>
									<tbody v-if="Boolean(cancelled_requests.length)">
										<tr align="center" v-for="(request, index) in cancelled_requests">
                                            <td>{{ (from - 1) + index + 1 }}</td>
											<td>{{ request.id }}</td>
											<td>
												{{ request.customer_name }}<br>
												+91 {{ request.mobile }}
											</td>
											<td>{{ request.location }}</td>
											<td>{{ request.product.product_name }} <br> 
												<span v-if="request.service_type == 1">New</span>
												<span v-else-if="request.service_type == 2">Repair</span>
												<span v-else>Replacement</span>
											</td>
											<td>{{ request.technician.name }}</td>
											<td>{{ request.cancellation_reason }}</td>
											<td>
												<span class="badge rounded-pill bg-warning" v-if="request.job_status == 1">Pending</span>
												<span class="badge rounded-pill bg-primary" v-else-if="request.job_status == 2">Ongoing</span>
												<span class="badge rounded-pill bg-success" v-else-if="request.job_status == 3">Completed</span>
												<span class="badge rounded-pill bg-secondary" v-else-if="request.job_status == 4">Enquiry</span>
												<span class="badge rounded-pill bg-danger" v-else>Cancelled</span>
											</td>
                                            <td>
												<button class="btn btn-danger btn-sm me-2" v-if="request.cancellation_status == 1" @click="cancelJob(request.id)">Cancel</button>
												<button class="btn btn-info btn-sm me-2" v-else @click="openModal(request.id)">Reassign</button>												
                                            </td>
                                        </tr>
                                    </tbody>
									<tbody v-else>
										<tr>
											<td colspan="9" class="text-center">No cancelled requests found</td>
										</tr>
									</tbody>
								</table>
							</div>

							<!----pagination starts --->
							<nav aria-label="Page navigation" class="mt-2">
								<ul class="pagination">
									<li class="page-item" v-for="(page, index) in pagination" :key="index" :class="[{ disabled: !page.url }, { active: page.active }]">
									<a class="page-link" href="#" @click.prevent="fetchCancelledJobs(page.url)" tabindex="-1">
										<span v-if="index === 0">Prev</span>
										<span v-else-if="index === pagination.length - 1">Next</span>
										<span v-else v-html="page.label"></span>
									</a>
									</li>
								</ul>
							</nav>
							<!----pagination ends --->
							
						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title=modal_title>
			<template #body>
				<form @submit.prevent="" enctype="multipart/form-data">
					<div class="row">
                       	<div class="col-md-12 form-group mt-2">
                            <label class="control-label">Technician<span class="text-danger">*</span></label>
                        	<select class="form-select" v-model="technician_id">
								<option value="">--Select--</option>
								<option  v-for="technician in technicians" :value="technician.id">{{ technician.name }}</option>
							</select>
                        </div>
                    </div>
					
					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" @click="reAssignJob()">{{ button_title }}</button>
						<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>


	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from 'vue'
import {Modal} from "bootstrap"
import DynamicModal from '@/components/dynamic_modal.vue'
import { get, post } from '@/utils/api';
import { routes } from '@/constants/routes';
import { useRouter } from 'vue-router';
import Swal from '@/utils/swal';

let dynamicmodal = null;


const router = useRouter();
const { proxy } = getCurrentInstance();

const listing_length = ref(10);
const keyword = ref("");
const modal_title = ref("Approve Request");
const button_title = ref("Save");
const errors = ref({});
const cancelled_requests = ref([]);
const job_id = ref("");
const technician_id = ref("");
const technicians = ref([]);
const from = ref(null);
const to = ref(null);
const total = ref(null);
const pagination = ref({});

const showModal = () => {
	fetchTechnicians();
    if (dynamicmodal) dynamicmodal.show();
};

const hideModal = () => {
    if (dynamicmodal) dynamicmodal.hide();
};

const closeModal = () => {
    hideModal();
};

const openModal = (id) => {
    errors.value = {};
	job_id.value = id;
    showModal();
};

const fetchTechnicians = () => {

	get(routes.AllTechnicians, {}, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                technicians.value = response.data.data;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const fetchCancelledJobs = (url = null) => {

	const params = {
		limit: listing_length.value,
		keyword: keyword.value
	}

	const requestUrl = url ?? routes.CancelledRequests;

	get(requestUrl, { params }, false)
		.then((response) => {
			if (response.status === 200) {
				console.log(response.data.data);
                cancelled_requests.value = response.data.data.data;
				pagination.value = response.data.data.links;
				from.value = response.data.data.from;
				to.value = response.data.data.to;
				total.value = response.data.data.total;
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});
};

const cancelJob = (id) => {

	const params = {
		job_id: id
	}

	get(routes.CancelJob, { params }, false)
		.then((response) => {
			if (response.status === 200) {
                Swal.fire('', response.data.message || 'Work cancelled successfully', 'success');
				fetchCancelledJobs();
            } else {
                Swal.fire('', response.data.message || 'Error fetching data', 'error');
            }
		})
		.catch((error) => {
			if (error.response?.status === 422) {
                Swal.fire('', 'Validation error', 'error');
            } else if (error.response?.status === 500) {
                Swal.fire('', error.response.statusText || 'Server error', 'error');
            } else if (error.response?.status === 401) {
                Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
                router.push({ name: 'login' });
            } else {
				Swal.fire('', error.response.data?.message || 'Error occured', 'error');
			}
		});

}

const reAssignJob = () => {

	const params = {
		job_id: job_id.value,
		technician_id: technician_id.value
	}

	get(routes.ReAssignJob, { params }, false)
	.then((response) => {
		if (response.status === 200) {
			Swal.fire('', response.data.message || 'Work reassigned successfully', 'success');
			closeModal();
			fetchCancelledJobs();
		} else {
			Swal.fire('', response.data.message || 'Error fetching data', 'error');
		}
	})
	.catch((error) => {
		if (error.response?.status === 422) {
			errors.value = error.response.data.message;
		} else if (error.response?.status === 500) {
			Swal.fire('', error.response.statusText || 'Server error', 'error');
		} else if (error.response?.status === 401) {
			Swal.fire('', error.response.statusText || 'Unauthorized', 'error');
			router.push({ name: 'login' });
		} else {
			Swal.fire('', error.response.data?.message || 'Error occured', 'error');
		}
	});

}

onMounted(() => {
	fetchCancelledJobs();
    dynamicmodal = new Modal(document.getElementById('dynamicmodal'));
});



</script>